import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { PlacementService,MasterService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.scss'],
  providers:[PlacementService,AppGlobals,MasterService]
})

export class CandidateComponent implements OnInit {

  studentarr:any[];
  depts:any[];
  catgories:any[];
 
  @ViewChild('dt') table: any;
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arrcanlst:any=[];
  sections:any=[];
  bloodgp:any=[];
  castecats:any=[];
  subcomb:any=[];
  oprtype:string;
  filtcatgory:any[];
  arhouse:any=[];
  aylist:any[];
  arpayopt:any=[];
  arfeequota:any=[];
  armot:any=[];
  arrcourse:any=[];
  objstudent:any;
  infocnt:any={};
  ttlcnt:any={};
  admdash:any={};
  arrmtongue:any=[];
  objregdata:any={};
  arrstudoctype:any=[];
  arrinst:any=[];
  stuid;
  selnst:any;
  clcd:any;
  arrcansum:any=[]
 
  //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
  tab=1;
  tab1=1;
  selcat:any=0;
  verifiedstatus:any;
  genders:any=[{value:'Male',name:'Male'},{value:'Female',name:'Female'},{value:'Trans',name:'Trans'}];
  statuses:any=[{name:'Enrolled'},{name:'Pending'},{name:'Selected'}];

  fileToUpload: File = null;

fData: FormData = new FormData;
dcid:any=0;
arrstudoc:any=[];
disuploadbtn=true;
status:any="Enrolled";
  //modalOption: NgbModalOptions = {};
  //filteredOptions: Observable<any[]>;
  constructor(private http: HttpClient, private mservice:MasterService,private pservice: PlacementService,private modalService: NgbModal,private apglobal:AppGlobals) {
this.clcd=localStorage.getItem('clcd');
  
   }

 

 

    

  ngOnInit(): void {
   
  
  this.getinstitute();

  }
 
  getcandidates(inid,status) {

    this.pservice.getcandidates(inid,status)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrcanlst = resultArray;
           this.getcandidinfocnt(inid);
        },
        error => console.log("Error :: " + error)
        )
  }

  getcandidinfocnt(inid) {

    this.pservice.getcandidinfocnt(inid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.infocnt = resultArray.placeinfocnt;
            this.ttlcnt = resultArray.totalcnt;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getcandidatesum(inid) {

    this.pservice.getcandidatesum(inid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrcansum = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  updplacement(inid,status,stuid) {

    this.pservice.updateplacement(inid,status,stuid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            //this.arrcanlst = resultArray;
            alert(resultArray.message);
           this.getcandidates(this.selnst,this.status)
        },
        error => console.log("Error :: " + error)
        )
  }
  getinstitute() {
    this.pservice.getinstitute()
        .subscribe(
        resultArray => {
            console.log('getinstitute', resultArray);
            this.arrinst = resultArray;
            this.selnst=resultArray[0].clid;
            this.getcandidates(resultArray[0].clid,this.status);
        },
        error => console.log("Error :: " + error)
        )
  }



  
 exportcandidate(insid){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.pservice.callurl+"export/exppla_candidates.php?clcd="+clcd+"&aycd="+aycd+"&insid="+insid+"&status="+this.status;

  // window.open(url,'','_blank');
  window.open(url);
 }

 printprofile(insid,stuid){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.pservice.callurl+"qrcode/candidateprofile.php?clcd="+clcd+"&aycd="+aycd+"&insid="+insid+"&stuid="+stuid;

  // window.open(url,'','_blank');
  window.open(url);
 }
}
